<sb-tag-entities [editable]="editable" [dtoId]="dtoId" [dtoType]="dtoType" [(tagEntities)]="tags"
                 (tagEntitiesChange)="tagsChange.emit(tags)" [tagCount]="tagCount()"></sb-tag-entities>

